<template>
  <div class="widget-head" :class="{ compact: compact }">
    <div class="left-widget-head">
      <slot></slot>
    </div>
    <div class="right-widget-head">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    compact: Boolean
  }
}
</script>

<style scoped>
.widget-head { /* border-bottom: 1px solid rgba(255, 255, 255, .07); */ display: flex; height: 40px; }
.widget-head.compact { border-bottom: 0; height: 39px; }
.left-widget-head { display: flex; }
.right-widget-head { display: flex; flex: 1 1; flex-direction: row-reverse; }
.widget-head .caption { flex-shrink: 0; font-size: 16px; height: 40px; line-height: 40px; }
</style>



// WEBPACK FOOTER //
// src/components/widget/MWidgetHead.vue